import type { GridColDef } from '@mui/x-data-grid';
import type { MeterForProductPageResponse } from '@weft/api-definition';
import type { FieldPath } from 'react-hook-form';
import { formatDate } from '../../../../../utils/date';
import { MetersTableActions } from './MetersTableActions';

export const METERS_COLUMNS_KEYS = Object.freeze({
  NAME: 'name',
  CREATED_AT: 'createdAt',
  CONTRACTS: 'contractsCount',
  ACTIONS: 'actions',
} satisfies Record<string, FieldPath<MeterForProductPageResponse> | 'actions'>);

export const METERS_COLUMNS: GridColDef<MeterForProductPageResponse>[] = [
  {
    field: METERS_COLUMNS_KEYS.NAME,
    headerName: 'Product Name',
    flex: 1,
    headerClassName: 'pl-6',
    cellClassName: 'pl-6',
  },
  {
    field: METERS_COLUMNS_KEYS.CREATED_AT,
    headerName: 'Created On',
    valueGetter: ({ row }) => formatDate(row.createdAt),
  },
  {
    field: METERS_COLUMNS_KEYS.CONTRACTS,
    width: 200,
    headerName: 'Contracts',
    headerAlign: 'right',
    align: 'right',
    headerClassName: 'pr-6',
    cellClassName: 'pr-6',
    valueGetter: ({ row }) => row.contractsCount,
  },
  {
    field: METERS_COLUMNS_KEYS.ACTIONS,
    headerName: '',
    sortable: false,
    width: 50,
    align: 'center',
    renderCell: ({ row }) => (
      <MetersTableActions
        meterId={row.id}
        row={row}
        meterName={row.name}
        disableDelete={row.contractsCount > 0}
      />
    ),
  },
];